import { render, staticRenderFns } from "./lotCards.vue?vue&type=template&id=22da77e5&"
import script from "./lotCards.vue?vue&type=script&lang=js&"
export * from "./lotCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports